import ConfigsWhiteLabel from "../config-whitelabel.json";
import axios from "axios";

export default async function GetConfigWhiteLabel() {
  let returnconfigWhitelabel: any;
  try {
    const origin = window.location.origin.replace(/(^\w+:|^)\/\//, "");
    let configsWhiteLabel: any | {};
    const hostname = window.location.hostname;
    let pathname = window.location.pathname;
    let configWhitelabel = null;

    for (let iTentativas = 0; iTentativas < 3; iTentativas++) {
      if (origin.includes("localhost") && ConfigsWhiteLabel) {
        configsWhiteLabel = ConfigsWhiteLabel;
        iTentativas = 3;
      } else {
        let href = window.location.href.replace(/(\/+|\/*\#.*)$/, "");
        configsWhiteLabel = await getConfig(`${href}/config-whitelabel.json`);
      }
      if (configsWhiteLabel) {
        configWhitelabel = configsWhiteLabel.find(
          (config: { identify: string }) =>
            hostname.indexOf(config.identify) === 0
        );
        if (!configWhitelabel) {
          // Se não encontrarmos o identify pelo hostname, vamos tentar pelo pathname
          // (para o caso específico do ambiente de teste https://sistemas.connectsa.com.br/<flavor-tetis>).
          const pathname = window.location.pathname.replace(/\//g, "");
          configWhitelabel = configsWhiteLabel.find(
            (config: { identify: string }) => config.identify === pathname
          );
        }
        //caso não encontre a identify, assumir um default
        if (!configWhitelabel) {
          configWhitelabel = configsWhiteLabel?.find(
            (config: { identify: string }) => config.identify === "localhost"
          );
        }
        break;
      }
    }
    if (!configsWhiteLabel) {
      console.error(
        "ERRO NA LEITURA DA CONFIGURAÇÃO. FAVOR REPORTAR ESTE ERRO PARA A EQUIPE TÉCNICA."
      );
      window.stop();
    }
    returnconfigWhitelabel = configWhitelabel;
  } catch (err) {
    console.error(err);
    // Fazer esquema pra fazer o logout
    setTimeout(() => {
      window.location.reload();
    }, 5000);

    // console.log( "PAREI NO CATCH" );
  }
  return returnconfigWhitelabel;
}

const getConfig = async (url: string) => {
  for (let iTentativas = 0; iTentativas < 3; iTentativas++) {
    try {
      let apiTemp = axios.create();
      let ret = await apiTemp.get(url);
      if (ret) {
        ret = ret.data;
      }
      return ret;
    } catch (err) {
      // console.log( "ERRO NO getConfig " + iTentativas );
      // console.error(err);
    }
  }
};
